import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { NetworkId, GetSingleNetworkResponseDto } from '../../types';
import { apiClient } from '../apiClient';
import { createQueryConfig } from '../config';

export function useGetSingleNetwork({
  networkId,
}: {
  networkId: NetworkId;
}): UseQueryResult<GetSingleNetworkResponseDto> {
  return useQuery({
    queryKey: ['networks', networkId],
    queryFn: async () => {
      const { data } = await apiClient.get(`/v1/networks/${networkId}`);
      return data;
    },
    ...createQueryConfig(),
  });
}
